import React from "react";
import { connect } from "react-redux";
import { uniq } from "lodash";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import compose from "lodash/flowRight";

import getEnvironmentApiTokens from "../graphql/getEnvironmentApiTokens.graphql";
import { setEnvironment } from "../reducers/environment-reducer";
import { getSelectedEnvironment } from "../selectors/environment";
import { Select } from "components/Form";
import { getApiTokens } from "../../selectors/apiTokens";
import { NO_ENVIRONMENT, ALL_ENVIRONMENTS } from "../../organization/constants";
import LoadingIcon from "components/svg/loading.svg";

const StyledLoadingIcon = styled(LoadingIcon)`
  margin-bottom: 20px;
`;

const EnvironmentSelectorWrapper = styled.div`
  width: 200px;
  padding-bottom: 20px;
`;

const Text = styled.p`
  margin-bottom: 8px;
`;

class EnvironmentSelector extends React.Component {
  onEnvironmentChange = ({ target: { value } }) => {
    this.props.setEnvironment(value);
  };

  componentDidMount() {
    const environmentsInUseCount = uniq(
      this.props.tokens.map(e => e.environment)
    ).filter(x => x).length;

    if (this.props.selectedEnvironment == "" && !this.props.isLoading) {
      if (environmentsInUseCount > 0) {
        this.props.setEnvironment(ALL_ENVIRONMENTS);
      } else {
        this.props.setEnvironment(NO_ENVIRONMENT);
      }
    }
  }

  getEnvironmentsOpt(tokens) {
    const unallocatedTokensCount = tokens.filter(item => !item.environment)
      .length;
    const environmentsInUse = uniq(tokens.map(e => e.environment)).filter(
      item => item
    );
    const sortedEnvironments = environmentsInUse.sort((element, nextElement) =>
      element.localeCompare(nextElement)
    );
    const environmentsInUseCount = environmentsInUse.length;

    if (environmentsInUseCount === 0 && unallocatedTokensCount > 0) {
      return [NO_ENVIRONMENT];
    } else if (environmentsInUseCount > 0 && unallocatedTokensCount === 0) {
      return [ALL_ENVIRONMENTS, ...sortedEnvironments];
    } else {
      return [ALL_ENVIRONMENTS, NO_ENVIRONMENT, ...sortedEnvironments];
    }
  }

  render() {
    const { tokens, isLoading } = this.props;

    return isLoading ? (
      <StyledLoadingIcon />
    ) : (
      <React.Fragment>
        <Text>Only environments with assigned tokens are being shown.</Text>
        <EnvironmentSelectorWrapper>
          <Select
            onChange={this.onEnvironmentChange}
            name="defaultDurationUnit"
            options={this.getEnvironmentsOpt(tokens)}
            value={this.props.selectedEnvironment}
          />
        </EnvironmentSelectorWrapper>
      </React.Fragment>
    );
  }
}

function mapSelectorsToProps(state, props) {
  return {
    tokens: getApiTokens(state, props),
    selectedEnvironment: getSelectedEnvironment(state, props),
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    setEnvironment: environment => dispatch(setEnvironment(environment)),
  };
}

export default compose(
  withRouter,
  connect(undefined, mapDispatchToProps),
  graphql(getEnvironmentApiTokens, {
    props: props => ({
      data: props.data,
      isLoading: props.data.loading,
    }),
  }),
  connect(mapSelectorsToProps)
)(EnvironmentSelector);
